import PropTypes from 'prop-types';
import React from 'react';

import {Grid} from "@mui/material";

import FeedImportInProgress from "./components/FeedImportInProgress";
import DeleteFeedButton from "./components/DeleteFeedButton";
import EditFeedButton from "./components/EditFeedButton";
import HistoryFeedButton from "./components/HistoryFeedButton";
import ImportButton from "./components/ImportButton";
import ForceImportButton from "./components/ForceImportButton";
import MapperButton from "./components/MapperButton";

FeedActions.propTypes = {
    feed: PropTypes.shape({
        id: PropTypes.string.isRequired,
        '@id': PropTypes.string.isRequired,
        dataType: PropTypes.string.isRequired,
        transportType: PropTypes.string.isRequired,
        mapper: PropTypes.string,
        configuration: PropTypes.object,
    }).isRequired,
};

function FeedActions({feed}) {
    if (feed.process !== 'idle') {
        return (
           <FeedImportInProgress feed={feed} />
        )
    }

    return (
        <Grid container justifyContent={"flex-end"} spacing={2} >
            <Grid item xs={1.5}>
                <DeleteFeedButton feed={feed} />
            </Grid>
            <Grid item xs={1.5}>
                <EditFeedButton feed={feed} />
            </Grid>
            <Grid item xs={1.5}>
                <MapperButton feed={feed} />
            </Grid>
            <Grid item xs={1.5}>
                <ImportButton feed={feed} />
            </Grid>
            <Grid item xs={1.5}>
                <ForceImportButton feed={feed} />
            </Grid>
            <Grid item xs={1.5}>
                <HistoryFeedButton feed={feed} />
            </Grid>
        </Grid>
    );
}


export default FeedActions;
